const filterRowsByInstrument = (table, instrument) => {
  if (!table) throw Error('No table found');

  const tbody = table.querySelector('tbody');
  const rows = [...tbody.rows];

  const filteredRows = rows.filter((row) => {
    const name = row.querySelector('[data-instrument]').textContent;

    // !GLOBAL VARIABLE!
    // if (instrument === ALL) return row;

    return name.includes(instrument);
  });

  return filteredRows;
};

export default filterRowsByInstrument;
